import { render, staticRenderFns } from "./editer.vue?vue&type=template&id=42a145af&scoped=true&"
import script from "./editer.vue?vue&type=script&lang=js&"
export * from "./editer.vue?vue&type=script&lang=js&"
import style0 from "./editer.vue?vue&type=style&index=0&id=42a145af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a145af",
  null
  
)

export default component.exports